module.exports = __webpack_public_path__ + "static/media/iconfont.15747f12.woff";